import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from './layouts/Default.vue'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import OpenTasks from "@/views/Task/OpenTasks.vue";
import ExecuteTask from "@/views/Task/ExecuteTask.vue";
import MyCases from "@/views/Case/MyCases.vue";
import Inbox from "@/views/Inbox.vue";
import Message from "@/views/Message.vue";
import ComposeMessage from "@/views/ComposeMessage.vue";
import ShowCase from "@/views/Case/ShowCase.vue";
import ShowTask from "@/views/Task/ShowTask.vue";
const routes = [
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: Home,
        meta: { requiresAuth: true }
      },
      {
        path: '/inbox',
        name: 'inbox',
        component: Inbox,
        meta: { requiresAuth: true }
      },
      {
        path: '/message/:user_id',
        name: 'message',
        component: Message,
        meta: { requiresAuth: true }
      },
      {
        path: '/compose-message/:case_id',
        name: 'compose-message',
        component: ComposeMessage,
        meta: { requiresAuth: true }
      },
      {
        path: '/url-login/:url',
        name: 'url-login',
        component: Login,
        meta: {requiresAuth: false}
      },
      {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {requiresAuth: false}
      },
      {
        path: '/open-tasks',
        name: 'open',
        component: OpenTasks,
        meta: { requiresAuth: true }
      },
      {
        path: '/my-reports',
        name: 'myreports',
        component: MyReports,
        meta: { requiresAuth: true }
      },
      {
        path: '/my-cases',
        name: 'mycases',
        component: MyCases,
        meta: { requiresAuth: true }
      },
      {
        path: '/case/:id',
        name: 'case',
        component: ShowCase,
        meta: { requiresAuth: true }
      },
      {
        path: '/execute-task/:id',
        name: 'execute-task',
        component: ExecuteTask,
        meta: { requiresAuth: true }
      },
      {
        path: '/task/:id',
        name: 'task',
        component: ShowTask,
        meta: { requiresAuth: true }
      },
      {
        path: '/logout',
        name: 'logout',
        component: Logout
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

import store from '@/stores/appStore.js';
import MyReports from "@/views/Case/MyReports.vue";

router.beforeEach((to, from, next) => {
  // Checking if the route requires being logged in
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  // Assume there's a boolean in your Vuex state indicating login status
  const token = store.state.token;

  if (requiresAuth && !token) {
    // Redirect to the login page if not logged in and trying to access a restricted route
    next({ name: 'login' });
  } else {
    // Proceed to the route
    store.dispatch('updateUnreadMessageCounter');
    next();
  }
});

export default router
